import { FC } from "react";
import { Center, Flex } from "@chakra-ui/react";
import { ChunkDivider } from "./ChunkDivider";
import { Logo } from "./Logo";
import { MobileDivider } from "./MobileDivider";
import { NewsletterChunk } from "./NewsletterChunk";
import { SocialMediaChunk } from "./SocialMediaChunk";
import { UnrequiredLinks } from "./UnrequiredLinks";

export const LandingAppOnlySection: FC = () => {
  return (
    <>
      <Flex
        align={{ base: "center", lg: "flex-start" }}
        flexDirection={{ base: "column", lg: "row" }}
        justify="center"
        w="100%"
      >
        <NewsletterChunk />
        <ChunkDivider />
        <SocialMediaChunk />
        <MobileDivider />
      </Flex>
      <Center>
        <Logo />
      </Center>
      <UnrequiredLinks />
    </>
  );
};
